import type { ContactComplianceFilter } from '@/utils/contactCompliance';
import type { QAScoreBand } from '@/utils/qaScores';

export type QADateRange = 'last7d' | 'last14d' | 'last30d' | 'last90d' | 'custom';

export interface QAFilters {
  dateRange: QADateRange;
  startDate?: string;
  endDate?: string;
  campaign?: string;
  sentiment?: 'positive' | 'neutral' | 'negative';
  consumerSignal?: ContactComplianceFilter;
  transferOnly: boolean;
  /** @deprecated Compatibility for older saved filter state; treated as concernScore='high'. */
  concernOnly: boolean;
  concernScore?: QAScoreBand;
  upsetScore?: QAScoreBand;
  reviewStatus?: 'all' | 'reviewed' | 'unreviewed' | 'valid' | 'invalid' | 'no_review';
  searchText?: string;
}

export const QA_ROLLING_WINDOWS: { value: Exclude<QADateRange, 'custom'>; label: string; days: number }[] = [
  { value: 'last7d', label: 'Rolling 7 days', days: 7 },
  { value: 'last14d', label: 'Rolling 14 days', days: 14 },
  { value: 'last30d', label: 'Rolling 30 days', days: 30 },
  { value: 'last90d', label: 'Rolling 90 days', days: 90 },
];

export function getQARollingDays(dateRange: QADateRange): number {
  return QA_ROLLING_WINDOWS.find((window) => window.value === dateRange)?.days ?? 7;
}

export function formatQAWindowLabel(filters: Pick<QAFilters, 'dateRange' | 'startDate' | 'endDate'>): string {
  if (filters.dateRange === 'custom') {
    if (filters.startDate && filters.endDate) return `${filters.startDate} → ${filters.endDate}`;
    if (filters.startDate) return `From ${filters.startDate}`;
    return 'Custom range';
  }
  const window = QA_ROLLING_WINDOWS.find((item) => item.value === filters.dateRange);
  if (!window) return 'Rolling 7 days';
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - (window.days - 1));
  const formatDate = (date: Date) => date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${window.label} (${formatDate(start)} – ${formatDate(end)})`;
}
